/**
 * The scroll behaviour to use for a programmatic scroll, honouring the reader's
 * reduced-motion setting.
 */
export const scrollBehaviour = (): ScrollBehavior =>
  window.matchMedia('(prefers-reduced-motion: reduce)').matches
    ? 'auto'
    : 'smooth';
